import { useQuery } from '@tanstack/react-query';
import { getNotifications } from '@/app/services/notificationService';

/**
 * Count of unread OTP alerts.
 *
 * Alerts no longer own a bottom tab, so this is what keeps them discoverable: it
 * badges the Profile tab and the Alerts row inside Profile. Without it, a
 * time-sensitive approval request would have no visible surface at all.
 */
export const useUnreadAlerts = (): number => {
    const { data } = useQuery({
        queryKey: ['unread-alerts'],
        queryFn: () => getNotifications(50, 0),
        refetchInterval: 60000,
        staleTime: 30000,
    });

    return (data?.notifications ?? []).filter((n) => n.status !== 'read').length;
};
